/* ============================================================
   Starstudio Theme — Main JavaScript
   ============================================================ */

document.addEventListener('DOMContentLoaded', function () {

  /* ─── Scroll Reveal ─── */
  const revealObs = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) e.target.classList.add('visible');
    });
  }, { threshold: 0.1 });
  document.querySelectorAll('.reveal').forEach(function (el) { revealObs.observe(el); });

  /* ─── Sticky Header ─── */
  var header = document.querySelector('.sts-header');
  if (header) {
    window.addEventListener('scroll', function () {
      header.classList.toggle('scrolled', window.scrollY > 40);
    }, { passive: true });
  }

  /* ─── Mobile Menu ─── */
  var mobileToggle = document.getElementById('sts-mobile-toggle');
  var mobileMenu   = document.getElementById('sts-mobile-menu');
  if (mobileToggle && mobileMenu) {
    mobileToggle.addEventListener('click', function () {
      var open = mobileMenu.classList.toggle('open');
      mobileToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      mobileToggle.innerHTML = open
        ? '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 6L6 18M6 6l12 12"/></svg>'
        : '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 12h18M3 6h18M3 18h18"/></svg>';
    });
  }

  /* ─── FAQ Accordion ─── */
  document.querySelectorAll('.sts-faq-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('.sts-faq-item');
      var isOpen = item.classList.contains('open');
      document.querySelectorAll('.sts-faq-item.open').forEach(function (i) { i.classList.remove('open'); });
      if (!isOpen) item.classList.add('open');
    });
  });

  /* ─── Typewriter Effect ─── */
  var typeEl = document.getElementById('sts-typewriter');
  if (typeEl) {
    var words = ['en Shopify', 'en Ecommerce', 'en México', 'en España', 'en LATAM'];
    if (typeEl.dataset.words) {
      try { words = JSON.parse(typeEl.dataset.words); } catch (e) { /* fallback */ }
    }
    var wordIdx = 0, charIdx = 0, deleting = false;

    function type() {
      var current = words[wordIdx % words.length];
      if (!deleting) {
        typeEl.textContent = current.slice(0, charIdx + 1);
        charIdx++;
        if (charIdx === current.length) {
          deleting = true;
          setTimeout(type, 1800);
          return;
        }
      } else {
        typeEl.textContent = current.slice(0, charIdx - 1);
        charIdx--;
        if (charIdx === 0) {
          deleting = false;
          wordIdx++;
        }
      }
      setTimeout(type, deleting ? 35 : 70);
    }
    type();
  }

  /* ─── Counter Animation ─── */
  function animateCounter(el, target, suffix, duration) {
    var start = null;
    function step(timestamp) {
      if (!start) start = timestamp;
      var progress = Math.min((timestamp - start) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      var prefix = el.dataset.prefix !== undefined ? el.dataset.prefix : '+';
      el.textContent = prefix + Math.floor(eased * target) + suffix;
      if (progress < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  var countersStarted = false;
  var metricsSection  = document.querySelector('.sts-metrics-section');
  if (metricsSection) {
    var counterObs = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting && !countersStarted) {
        countersStarted = true;
        document.querySelectorAll('[data-counter]').forEach(function (el) {
          animateCounter(el, +el.dataset.counter, el.dataset.suffix || '', 2200);
        });
      }
    }, { threshold: 0.3 });
    counterObs.observe(metricsSection);
  }

  /* ─── Scroll progress bar ─── */
  var progress = document.createElement('div');
  progress.className = 's2-progress';
  document.body.appendChild(progress);
  window.addEventListener('scroll', function () {
    var h = document.documentElement;
    var pct = (h.scrollTop) / (h.scrollHeight - h.clientHeight) * 100;
    progress.style.width = pct + '%';
  }, { passive: true });

  /* ─── Calculadora de pérdida SEO ─── */
  var calcBtn = document.getElementById('s2c-btn');
  if (calcBtn) {
    calcBtn.addEventListener('click', function () {
      var visits = parseFloat(document.getElementById('s2c-visits').value) || 0;
      var ticket = parseFloat(document.getElementById('s2c-ticket').value) || 0;
      var cr     = (parseFloat(document.getElementById('s2c-cr').value) || 0) / 100;
      if (!visits || !ticket || !cr) return;
      /* Escenario conservador: SEO bien ejecutado suma ~60% de tráfico orgánico
         incremental al año sobre la base actual */
      var extraAnual = Math.round(visits * 0.6 * cr * ticket * 12);
      var resultBox = document.getElementById('s2c-result');
      var numEl = document.getElementById('s2c-num');
      resultBox.style.display = 'block';
      numEl.textContent = '$' + extraAnual.toLocaleString('en-US') + ' USD';
      var waEl = document.getElementById('s2c-wa');
      var msg = 'Hola, usé la calculadora: mi tienda podría generar ~$' + extraAnual.toLocaleString('en-US') + ' USD extra al año con SEO. Quiero mi auditoría gratis. Mi tienda es: ';
      waEl.href = 'https://wa.me/15559707346?text=' + encodeURIComponent(msg);
    });
  }

});
